<body>
  <div class="grid-overlay assistant-page">
    <app-page-header>
      <app-admin-session-switcher></app-admin-session-switcher>
    </app-page-header>

    <div class="assistant-page__body">
      <button class="assistant-page__sidebar-toggle" (click)="toggleSidebar()" type="button">
        ☰ {{ 'assistantPage.title' | translate }}
      </button>

      <aside class="assistant-page__sidebar" [class.assistant-page__sidebar--open]="sidebarOpen">
        <app-conversation-list
          [activeConversationId]="activeConversationId"
          (selectConversation)="onSelectConversation($event)"
          (newChat)="onNewChat()">
        </app-conversation-list>
      </aside>

      @if (sidebarOpen) {
        <div class="assistant-page__backdrop" (click)="toggleSidebar()"></div>
      }

      <main class="assistant-page__chat">
        @if (loadingConversation) {
          <div class="assistant-page__chat-loading">
            <span class="assistant-page__spinner" aria-hidden="true"></span>
            <span>{{ 'assistantPage.chat.loadingConversation' | translate }}</span>
          </div>
        } @else {
          <app-assistant-chat></app-assistant-chat>
        }
      </main>
    </div>
  </div>
</body>
